import React from "react";
import BaseApi from "../../utils/BaseApi";
import {CircularProgress} from "@mui/joy";
import CommonDetail from "../Common/CommonDetail";
import withRouter from "../../utils/withRouter";

// components
import LeadTab from "./LeadTab";
import LeadDetailHeader from "./LeadDetailHeader";
import AttachmentsTab from "../Attachment/AttachmentsTab";
import LetterTab from "../Letter/LetterTab";
import QualificatorTab from "../Qualificator/QualificatorTab";

// icons
import InfoIcon from '@mui/icons-material/Info';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ScaleIcon from "@mui/icons-material/Scale";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import ContactsTab from "../Contact/ContactsTab";


class LeadDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lead: null,
        };
    }

    async componentDidMount() {
        await this.retrieveLead();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveLead();
        }
    }

    async retrieveLead() {
        await this.setState(
            {
                lead: null
            }
        );
        const url = `lead/${this.props.params.leadId}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        if (response.status === 200){
            this.setState(
                {
                    lead: response.data
                }
            );
        }
    }

    render() {
        if (!this.state.lead) {
            return (<CircularProgress/>)
        }
        return (
            <CommonDetail
                appName={'Lead'}
                appId={this.state.lead.id}
                header={{
                    component: LeadDetailHeader,
                    componentProps: {
                        lead: this.state.lead,
                    },
                    leftOverflow: {
                        icon: null,
                        title: 'Лид',
                        color: 'primary'
                    },
                }}
                defaultTabValue={'info'}
                tabComponents={[
                    {
                        title: 'Информация',
                        value: 'info',
                        icon: InfoIcon,
                        component: <LeadTab
                            lead={this.state.lead}
                            callBack={this.retrieveLead.bind(this)}
                        />,
                    },
                    {
                        title: 'Контакты',
                        value: 'contact',
                        icon: ContactPageIcon,
                        component: <ContactsTab
                            entity={'Lead'}
                            entity_id={this.state.lead.id}
                        />
                    },
                    {
                        title: 'Вложения',
                        value: 'attachment',
                        icon: AttachFileIcon,
                        component: <AttachmentsTab
                            appId={this.state.lead.id}
                            appName={'Lead'}
                        />
                    },
                    {
                        title: 'Квалификатор',
                        value: 'qualificator',
                        icon: ScaleIcon,
                        component: <QualificatorTab
                            qualificatorId={this.state.lead.qualificator}
                            lead={this.state.lead}
                        />,
                    },
                    {
                        title: 'Исходящие письма',
                        value: 'addresses',
                        icon: ForwardToInboxIcon,
                        component: <LetterTab
                            lead={this.state.lead}
                            account={this.state.lead.account}
                            contact={this.state.lead.contact}
                        />,
                    },
                ]}
            />
        )
    }
}

export default withRouter(LeadDetail);
